import React from 'react';
import { Waypoint } from 'react-waypoint';
import qs from 'qs';

import callApi from '../../utils/callApi';
import FeaturedSection from '../../components/featuredComponents/FeaturedSection';
import VideoPlayer from '../../components/videoComponents/VideoPlayer';
import LockedVideo from '../../components/videoComponents/LockedVideo';
import PromoSection from '../../components/promoComponents/PromoSection';
import FixedVideo from '../../components/promoComponents/FixedPromoVideo';
import { ARHIVE_LIST } from '../../constants/apiUrls/apiUrls';
import { PROMO_CODES } from '../../constants/promoCodes';
import { getCookie } from '../../utils/helpers';
import CoRegModal from '../../components/generalComponents/CoRegModal';


class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastSegment: null,
      displayFixedVideo: false,
      showCoRegModal: false,
    };
  }

  componentDidMount() {
    const canonicalTag = document.createElement('link');
    canonicalTag.setAttribute('rel', 'canonical');
    canonicalTag.setAttribute('href', 'https://nakednews.com');

    document.head.appendChild(canonicalTag);
    document.title = 'Home | Naked News is an adult news and entertainment program, with a gorgeous cast of anchors, where the facts aren\'t the only thing stripped down.';

    const {
      location: { search },
      user: { authenticated },
    } = this.props;
    const params = qs.parse(search, { ignoreQueryPrefix: true });

    if (params._atc === PROMO_CODES.CAM4_SOURCE && !authenticated) {
      this.setState({ showCoRegModal: true });
    }

    const baseUrl = ARHIVE_LIST;
    const parsedUrl = baseUrl.replace('{page}', 1).replace('{size}', 1);
    callApi(parsedUrl, 'get', {}).then((res) => {
      this.setState({ lastSegment: res.data.segments[0] });
    });
  }

  hideFixedVideo = () => {
    this.setState({ displayFixedVideo: false });
  };

  displayFixedVideo = () => {
    sessionStorage.getItem('HIDE_FIXED_VIDEO') ? this.setState({ displayFixedVideo: false }) : this.setState({ displayFixedVideo: true });
  };

  videoControl = (e) => {
    if (!e.target.hasAttribute('href')) {
      e.preventDefault();
    }
  };

  render() {
    const { user, history, location, activeCampaign } = this.props;
    const {
      lastSegment,
      displayFixedVideo,
      showCoRegModal,
    } = this.state;

    // Promo Campaign check
    const isGuest = user && !user.authenticated;
    // const hasPromoControlledFeature = user.features.includes(
    // PROMO_CODES.BACK_TO_SCHOOL_PROMO
    // );
    const hasAtc = getCookie('_atc');
    const promoBlockedByAtc =
      hasAtc && (hasAtc === PROMO_CODES.CAM4_SOURCE);
    const isAnchor =
      user && user.user && user.user.username && user.user.account.anchor;

    // Subscription check
    const isSubscriptionExpired =
      user.authenticated && !user.user.activeSubscription;

    const { affiliateCode, videoImage, mainImage, mainMobileImage, backgroundColor } = activeCampaign || {};

    const showPromoSectionForCampaign = affiliateCode &&
      affiliateCode !== PROMO_CODES.NNLIVEMRSK4 &&
        affiliateCode !== PROMO_CODES.ASNAW22 && !user.authenticated;
    const checkoutURL = '/account/purchase';

    return (
      <React.Fragment>
        {!promoBlockedByAtc && showPromoSectionForCampaign
          && !isAnchor ? (
          (
            <React.Fragment>
              <FixedVideo
                close={this.hideFixedVideo}
                displayFixedVideo={displayFixedVideo}
                user={user}
                videoImage={videoImage}
                homePage={true}
              />
              <Waypoint onEnter={this.hideFixedVideo} onLeave={this.displayFixedVideo}>
                <div>
                  <PromoSection
                    backgroundColor={backgroundColor}
                    checkoutURL={checkoutURL}
                    homePage={true}
                    isCampaignActive={true}
                    mainImage={mainImage}
                    mainMobileImage={mainMobileImage}
                    user={user}
                    videoControl={this.videoControl}
                  />
                </div>
              </Waypoint>
            </React.Fragment>
          )
        ) : !isSubscriptionExpired || isAnchor ? (
          <VideoPlayer homePage={true} isProgram={true} user={user} />
        ) : (
          lastSegment && (
            <div
              className="homepageLockedVideo"
              style={{ overflow: 'auto' }}
            >
              <LockedVideo videoElement={lastSegment} />
            </div>
          )
        )}

        <FeaturedSection history={history} location={location} />
        <CoRegModal show={showCoRegModal} />
      </React.Fragment>
    );
  }
}

export default HomePage;
